export const findCollectiveScope = (user) => {

    if (!user.scopes)
        return null;

    if (user.scopes.includes('ais')) return 'ais';
    else if (user.scopes.includes('s2e')) return 's2e';
    throw new Error('User has no collective scopes.');
};
